<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <!-- Creator: CorelDRAW 2020 (64 Bit) -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="441px"
    height="450px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 64.95 66.32"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_2264819310272">
        <path
          class="fil0"
          d="M0.05 4.76c0.07,3.55 0,7.21 0,10.78 0,3.58 0,7.17 0,10.76 0,7.18 0,14.36 0,21.54 0,1.5 -0.14,3.91 0.06,5.3 0.2,1.47 1.12,2.86 1.87,3.54 1.62,1.47 5.01,2.59 7.15,3.61 2.45,1.16 5.01,2.15 7.49,3.29l5.66 2.46c0.77,0.33 1.52,0.47 2.08,-0.16 0.51,-0.57 0.39,-1.41 0.4,-2.25l0 -45.78c0,-2.16 -0.19,-2.78 -1.97,-3.47 -6.41,-2.49 -13.12,-4.9 -19.49,-7.45 -2.47,-0.98 -2.75,-1.89 -3.25,-2.17z"
        />
        <path
          class="fil0"
          d="M24.44 8.02c1.25,-0.17 30.15,-0.12 31.3,-0.12 1.47,-0.01 2.1,-0.04 3.27,0.6 0.72,0.4 1.52,1.24 1.89,2.07 0.52,1.15 0.43,2.09 0.43,3.45l0 43.27c-0.01,2.22 -1.01,4.11 -3.38,4.46 -0.96,0.14 -14.34,0.04 -15.69,0.04 -2.62,0 -5.24,0 -7.86,0 -2.23,0 -2.97,-0.11 -4.93,-0.96 -0.47,-0.2 -0.9,-0.47 -1.35,-0.63 -0.14,-4.28 0.02,-8.72 -0.01,-13.02 -0.06,-8.65 0.01,-17.38 -0.02,-26.06 -0.01,-4.16 0.56,-6.48 -2.63,-8.8 -0.3,-0.22 -0.75,-0.42 -1,-0.64l-0.02 -3.66zm2.06 55.53c0.4,0.32 2.15,0.97 2.78,1.18 1.07,0.34 2.21,0.6 3.4,0.63 2.66,0.06 5.39,0.01 8.06,0 5.37,0 10.75,-0.02 16.12,0 1.33,0.01 2.38,0.03 3.55,-0.42 1.92,-0.76 3.28,-2.12 4.04,-4.03 0.48,-1.21 0.43,-2.28 0.43,-3.62l0 -40.24c0,-3.09 0.45,-6.83 -0.93,-9.13l-0.85 -1.2c-0.42,-0.54 -1.45,-1.32 -2.31,-1.72 -2.09,-0.97 -4.96,-0.67 -7.43,-0.67 -5.37,0.01 -10.75,0.03 -16.12,0.02 -2.66,0 -5.33,0.05 -7.99,0.04 -2.26,-0.01 -11.01,-2.18 -13.46,-2.68 -2.21,-0.46 -4.42,-1.01 -6.63,-1.41 -2.44,-0.44 -4.84,-0.54 -6.67,0.77 -0.73,0.52 -1.56,1.46 -0.65,2.57 0.52,0.64 1.5,1.09 2.52,1.51 5.79,2.35 11.61,4.45 17.36,6.75 0.96,0.39 1.98,0.68 2.81,1.22 0.68,0.45 1.36,1.31 1.72,2.31 0.46,1.3 0.25,6.11 0.25,7.83l0 24.18c0,5.36 0.07,10.76 0,16.11z"
        />
        <path
          class="fil0"
          d="M33.89 15.84c-2.2,0.18 -2.56,3.28 -0.5,4.01 0.6,0.21 15.52,0.09 17.99,0.1 1.1,0 2.56,0.08 3.62,-0.01 2.13,-0.17 2.54,-3.33 0.41,-4.02 -0.63,-0.21 -12.63,-0.09 -14.34,-0.09 -1.38,0 -6.23,-0.07 -7.18,0.01z"
        />
        <path
          class="fil0"
          d="M33.82 22.72c-0.79,0.12 -1.35,0.58 -1.61,1.19 -0.34,0.8 -0.16,1.56 0.26,2.14 0.41,0.58 1.01,0.76 2,0.77 1.39,0 13.48,0.05 14.04,-0.02 1.32,-0.15 2.38,-1.85 1.28,-3.34 -0.38,-0.51 -1.06,-0.76 -1.98,-0.76 -1.46,0.01 -13.45,-0.06 -13.99,0.02z"
        />
        <path
          class="fil0"
          d="M48.4 54.3l0.02 -6.87c-0.44,-0.13 -3.4,-0.04 -4.11,-0.04 -1.34,-0.01 -2.76,0.05 -4.08,0l0 6.91 8.17 0zm-15.65 -14.92c-0.04,0.77 -0.07,6.71 0.03,7.04 2.2,0.17 4.42,0.4 6.62,0.5 2.35,0.11 4.79,-0.03 7.16,0.03 -0.23,-0.38 -0.48,-0.44 -0.73,-0.69 -0.28,-0.31 -0.39,-0.39 -0.68,-0.64l-1.38 -1.26c-0.28,-0.26 -0.23,-0.28 -0.71,-0.67 -0.25,-0.2 -0.42,-0.42 -0.68,-0.63 -0.54,-0.45 -2.56,-2.42 -2.82,-2.51 -0.4,-0.12 -3.81,-0.66 -4.54,-0.79 -0.73,-0.13 -1.54,-0.31 -2.27,-0.38zm7.56 -0.53c1.7,0.06 6.3,0.04 8.01,-0.01l0.01 -6.06 -8.02 0.01 0 4.8 0 1.26zm-5.56 0.52c0.43,0.02 1.47,0.25 2.01,0.33l3.1 0.49 1.28 1.11c0.12,0.11 0.17,0.2 0.29,0.31l4.05 3.68c0.32,0.27 0.99,0.85 1.21,1.13l9.23 -0.02 -0.02 -7.05 -21.15 0.02z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
